import script from "./PushDebugOverlay.vue?vue&type=script&setup=true&lang=ts"
export * from "./PushDebugOverlay.vue?vue&type=script&setup=true&lang=ts"

import "./PushDebugOverlay.vue?vue&type=style&index=0&id=a5857cd6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5857cd6"]])

export default __exports__